"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var NavigationMenuItem_styled_exports = {};
__export(NavigationMenuItem_styled_exports, {
  StyledMenuItem: () => StyledMenuItem,
  StyledOption: () => StyledOption
});
module.exports = __toCommonJS(NavigationMenuItem_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_Link = require("../../atoms/Link/Link.component");
var import_NavigationMenuButton = require("./NavigationMenuButton.styled");
var StyledOption = (0, import_styled_components.default)(import_Link.Link).withConfig({
  displayName: "NavigationMenuItemstyled__StyledOption",
  componentId: "sc-uhozku-0"
})(function(_ref) {
  var theme = _ref.theme, optionsOverflow = _ref.optionsOverflow, selected = _ref.selected, disabled = _ref.disabled, maxVisibleChars = _ref.maxVisibleChars;
  return (0, import_styled_components.css)(["display:flex;align-items:center;justify-content:space-between;color:", ";cursor:pointer;padding:20px 15px;font-size:", ";white-space:", ";&:hover{background-color:", ";text-decoration:none;}&:focus{outline-color:", ";border:", " 2px solid;}&:active,&:visited,&:hover,&:link{color:", ";}", " ", ";.navigation__menuitem-content{", " ", " ", " align-items:center;display:block;overflow:hidden;width:90%;i{&:first-child{margin-right:5px;}&:last-child{margin-left:5px;}}}"], theme.colors.n[100], theme.typography.sizes.medium, maxVisibleChars ? "normal" : !maxVisibleChars && optionsOverflow === "ellipsis" ? "nowrap" : "normal", theme.colors.beige[100], theme.colors.beige[180], theme.colors.beige[180], theme.colors.n[100], selected && (0, import_styled_components.css)(["&:link{font-weight:bold;}&:after{content:'';display:inline-block;transform:rotate(45deg);width:6px;height:12px;border-bottom:2px solid ", ";border-right:2px solid ", ";}"], theme.colors.pr.base, theme.colors.pr.base), disabled && (0, import_NavigationMenuButton.disabledStyles)(theme, false, false), maxVisibleChars && "word-wrap: break-word;", !maxVisibleChars && optionsOverflow === "ellipsis" && "text-overflow: ellipsis;", !maxVisibleChars && optionsOverflow === "word-wrap" && "word-wrap: break-word;");
});
var StyledMenuItem = import_styled_components.default.li.withConfig({
  displayName: "NavigationMenuItemstyled__StyledMenuItem",
  componentId: "sc-uhozku-1"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["border-top:1px solid ", ";&:first-child{border-top:none;}"], theme.colors.beige[180]);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledMenuItem,
  StyledOption
});
//# sourceMappingURL=NavigationMenuItem.styled.js.map